import type { ImageSources } from '@/components/Image/ArtDirectedImage';
import MediaOverlay from '@/components/MediaOverlay/MediaOverlay';
import type { HeroFullOverlayContent } from '@/components/TopLevelComponents/HeroFullOverlay/HeroFullOverlay';
import HeroFullOverlayInnerContent from '@/components/TopLevelComponents/HeroFullOverlay/InnerContent/InnerContent';
import { ContentStyle } from '@/contentful/contentful-exports';
import { ViewportSize } from '@/styles/viewportSize';

import useStyles from './Slide.styles';

interface Props {
  slide: HeroFullOverlayContent;
}

export default function HeroCarouselSlide({ slide }: Props) {
  const {
    fields: {
      backgroundImages = [],
      backgroundVideos = [],
      applyDarkOverlay,
      eyebrow,
      style,
      heading,
      subheading,
      primaryCta,
      secondaryCta,
    },
  } = slide;

  const { classes, cx } = useStyles();
  const isOnDark = style === ContentStyle.OnDark;

  const images: ImageSources = {
    fallback: [backgroundImages[0], ViewportSize.xl],
    xs: [backgroundImages?.[2], ViewportSize.sm],
    sm: [backgroundImages?.[1], ViewportSize.md],
    md: [backgroundImages[0], ViewportSize.xl],
  };

  const videos = {
    fallback: backgroundVideos[0],
    xs: backgroundVideos[2],
    sm: backgroundVideos[1],
    md: backgroundVideos[0],
  };

  return (
    <MediaOverlay
      images={images}
      videos={videos}
      darken={applyDarkOverlay}
      className={classes.hFull}
      overlayClassName={classes.hFull}
    >
      <div className={cx(classes.immersive, classes.innerContentSpacing)}>
        <HeroFullOverlayInnerContent
          isOnDark={isOnDark}
          eyebrow={eyebrow}
          heading={heading}
          subheading={subheading}
          primaryCta={primaryCta}
          secondaryCta={secondaryCta}
          horizontalAlignment='Left'
          slideMode
        />
      </div>
    </MediaOverlay>
  );
}
